module.exports = __webpack_public_path__ + "static/media/company1.9be3e523.jpg";